import { MenuItem } from '@chakra-ui/react';
import Dialog from 'components/Dialog';
import InputMy from 'components/InputMy';
import showMessage from 'providers/NoticeProvider/showMessage';
import { useState } from 'react';
import { LuPencilLine } from 'react-icons/lu';
import { useParams } from 'react-router-dom';
import { useAppDispatch } from 'store/hooks';
import { fetchSingleTeamAgents, fetchTeams, updateTeam } from 'store/slices/teams';

type TProps = {
    title: string;
    id: string;
};

const EditTeamNameDialog = ({ title, id }: TProps) => {
    const { slug } = useParams();
    console.log(slug);

    const dispatch = useAppDispatch();
    const [value, setValue] = useState(title);
    const [loading, setLoading] = useState(false);

    const handleSubmit = () => {
        try {
            setLoading(true);
            dispatch(updateTeam({ title: value, id }))
                .unwrap()
                .then(() => {
                    showMessage('The team name has been successfully changed.');
                    if (slug) {
                        dispatch(fetchSingleTeamAgents({ id: slug }));
                    } else {
                        dispatch(fetchTeams());
                    }
                })
                .catch(error => {
                    console.log(error);
                    showMessage('Ooops', 'error');
                })
                .finally(() => {
                    setLoading(false);
                });
        } catch (e) {
            return false;
        }
    };

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => setValue(event.target.value);

    const disabled = value === title || !value?.length;

    return (
        <Dialog
            title="Edit team name"
            trigger={<MenuItem icon={<LuPencilLine />}>Edit name</MenuItem>}
            submitText="Change name"
            onSubmit={handleSubmit}
            disabled={disabled}
            loading={loading}
        >
            <InputMy label="Team name" placeholder="Enter name" value={value} onChange={handleChange} />
        </Dialog>
    );
};

export default EditTeamNameDialog;
